module.exports = __webpack_public_path__ + "img/tasks_lighten.a2904234.svg";